<div
  [style.backgroundColor]="imageUrl ? '' : backgroundColor"
  class="badge {{ size }} d-flex justify-content-center align-items-center"
  [title]="title"
>
  <span *ngIf="!imageUrl" [style.color]="foregroundColor">{{ content }}</span>
  <img *ngIf="imageUrl" [src]="imageUrl" />
</div>
